<template>
  <div class="leaflet-subunit-box">
    <slot></slot>
  </div>
</template>
<script>
import L from "leaflet";
import 'leaflet/dist/leaflet.css';
import 'leaflet.pm';
import 'leaflet.pm/dist/leaflet.pm.css';
import markerDefaultBlue from '@/assets/images/map/mark_default_blue.png';

import langMap from '@/utils/language';
import { mapState } from 'vuex';
import mapIntersectionUtil from '@/utils/mapIntersectionUtil';

export default {
  name: 'leafletSubunit',
  props: {
    // 绘制区域用的颜色集
    areaColor: {
      type: Array,
      default: () => ['', '', '']
    }
  },
  data() {
    return {
      langMap:langMap,
      defaultMap: '', //默认地图，高德amap，通用地图leaflet，默认通用地图；
      defaultMapUrl: '', //默认地图url，通用地图默认url
      placeSearch: null,
      map: null,
      line: null,
      markers: [],
      nodeTypeList: [],
      btnLoading: false,
      saveModal: false,
      nodeList: [],
      tableLoading: false,
      areaLayers: [], // 添加用于存储区域图层的数组
      intersectionLayers: [], // 添加用于存储交叉区域图层的数组
      currentDrawHandler: null, // 当前绘制事件处理器
    }
  },
  computed: {
    ...mapState({
      lang: state => state.app.language,
      mapConfig: state => state.app.leafletConfig
    }),
  },
  methods: {
    //初始化地图
    initMap(mapKey,mapUrl) {
      const tileLayerOption = this.mapConfig.tileLayerOption
      this.map = L.map("station_map_id", this.mapConfig.mapInstantiated);
      L.tileLayer(tileLayerOption.url, tileLayerOption).addTo(this.map);

      //添加绘制控制组件
      this.map.pm.setLang(this.lang || 'zh');
      this.map.pm.addControls({
        position: 'topleft',
        drawPolygon: false, // 绘制多边形
        drawMarker: false, //绘制标记点
        drawCircleMarker: false, //绘制圆形标记
        drawPolyline: false, //绘制线条
        drawRectangle: false, //绘制矩形
        drawCircle: false, //绘制圆圈
        editMode: false, //编辑多边形
        dragMode: false, //拖动多边形
        cutPolygon: false, // 添加一个按钮以删除多边形里面的部分内容
        removalMode: false // 清除多边形
      });
    },
    //初始化绘制区域
    initTargetArea(areaList) {
      const dataList = areaList || [];
      this.areaLayers = []; // 清空现有图层

      dataList.forEach((item, index) => {
        if (item.area !== null) {
          let color = this.areaColor[item.type];

          let areas = JSON.parse(item.area);
          let areaTemp = [];
          areas.forEach((item1, index1, arr1) => {
            let point = [item1.lat, item1.lon];
            areaTemp[index1] = point;
          });

          let polygon = L.polygon(areaTemp, {
            color: color,
            id: item.id,
            type: item.type,
            stationId: item.stationId, // 添加 stationId
            layerPriority: item.layerPriority || 0, // layerPriority，并提供默认值
            createTime: item.createTime
          }).addTo(this.map);

          // 保存到图层数组中
          this.areaLayers.push(polygon);
        }
      });

      // 3. 计算并显示交叉区域
      this.findAndDisplayIntersections();
    },
    //初始化站点
    initStations(dataList) {
      // 移除所有点
      this.markers.forEach(p => {
        this.map.removeLayer(p);
      });

      this.nodeList = JSON.parse(JSON.stringify(dataList));
      // 绘制点、线、设置中心
      this.nodeList.forEach((item, index) => {
        if (item.lat !== null && item.lng !== null) {
          this.createMarker([item.lat, item.lng], item);
        }
      });
    },
    moveToCenter(point) {
      this.map.panTo([point[1], point[0]]);
    },
    //创建节点，添加移动事件，链接点之间的线
    createMarker(point, item) {

      let icon = new L.divIcon({
        html: '<div style="width: 100px;font-size: 12px;font-weight: 700;color: #9e59a3;">' + item.name + '</div><img src="' + markerDefaultBlue + '" style="width: 15px;height: 15px;" />',
        className: 'my-div-icon',
        iconAnchor: [6, 28],
      });
      let marker = L.marker(point, {
        icon: icon,
        title: item.name,
        draggable: true,
        'id': item.id,
      }).addTo(this.map);
      // 保存所有点
      this.markers.push(marker);

      // 点位拖动事件
      let _this = this;
      marker.on("dragend", function (e) {
        _this.updateMarkerPoint(marker.getLatLng(), item.id);
      });

      //弹出信息层
      marker.on('click', function (e) {
        _this.createPopup(item.id);
      });
      return marker;
    },
    createPopup(id) {
      let node;
      this.nodeList.forEach((item, index, arr) => {
        if (item.id === id) {
          node = item;
        }
      });
      if (node && node.lng && node.lat) {
        let _str = node.description || '';
        let content = '<div class="input-card content-window-card"><div style="padding:7px 0px 0px 0px;">'
          + '<h4>' + langMap.name[this.lang] + '：' + node.name + '</h4>'
          + '<p class="input-item">' + langMap.latLng[this.lang] + '：[' + node.lng + ', ' + node.lat + ']' + '</p>'
          + '<p class="input-item">' + langMap.description[this.lang] + '：' + _str + '</p>'
          + '</div></div>';

        let popup = L.popup({ offset: [0, -15] })
          .setLatLng([node.lat, node.lng])
          .setContent(content);
        popup.openOn(this.map);
      }
    },
    // 获取点集合
    getMarkerPoints() {
      let markerPoints = [];
      this.nodeList.forEach((item, index, arr) => {
        if (item.lat !== null && item.lng !== null) {
          markerPoints.push([item.lat, item.lng]);
        }
      });
      return markerPoints;
    },
    //更新点位置
    updateMarkerPoint(point, id) {
      let _item = null;
      this.nodeList.some((item, index, arr) => {
        //通过临时id查找
        if (item.id === id) {
          item.lat = point.lat;
          item.lng = point.lng;
          this.$set(this.nodeList, index, item);
          _item = item;
          return true;
        }
      });

      this.$emit('updateNode', _item);
    },
    //点击按钮添标记点，每次追加
    addMarker(row) {
      const handleEvt = (obj) => {
        //创建marker点
        let lat, lng;
        lat = obj.latlng.lat;
        lng = obj.latlng.lng;

        this.createMarker([lat, lng], row);
        //更新节点中点经纬度
        row.lat = lat;
        row.lng = lng;

        //this.nodeList.push(row);
        this.$emit('updateNode', row);
        // 移除监听
        this.map.off('click', handleEvt);
      }

      // 保存事件处理器以便取消时使用
      this.currentDrawHandler = handleEvt;
      this.map.on('click', handleEvt);
    },
    // 取消绘制
    cancelDrawing() {
      // 移除地图点击监听
      if (this.currentDrawHandler) {
        this.map.off('click', this.currentDrawHandler);
        this.currentDrawHandler = null;
      }
    },
    //删除节点
    delMarker(row) {
      this.nodeList.forEach((item, index, arr) => {
        //通过临时id查找
        if (item.id === row.id) {
          this.nodeList.splice(index, 1);
          //删除marker
          this.markers.forEach((item1, index1, arr1) => {
            if (item1.options.id === item.id) {
              this.map.removeLayer(item1);
            }
          });
        }
      });
      //重新编排序号
      this.nodeList.forEach((item, index, arr) => {
        item.nodeOrder = index + 1;
        this.$set(this.nodeList, index, item);
      });
      this.$emit('updateNode', this.nodeList);
    },
    // 4. 添加计算并显示交叉区域的方法
    findAndDisplayIntersections() {
      // 使用工具类计算并显示交叉区域
      this.intersectionLayers = mapIntersectionUtil.findAndDisplayIntersections(
        this.map,
        this.areaLayers,
        this.intersectionLayers
      );
    }
  }
}
</script>
<style scoped>
.leaflet-subunit-box{height: 100%;}
</style>
